import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import Item from './Item';

interface SortableItemProps {
  id: string;
  pattern: string;
  activeId: string | null;
  disabled: boolean;
  hintLocked?: boolean;
}

const SortableItem: React.FC<SortableItemProps> = ({
  id,
  pattern,
  activeId,
  disabled,
  hintLocked = false,
}) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id, animateLayoutChanges: () => false });

  const style = {
    transform: disabled ? '' : CSS.Transform.toString(transform),
    transition: disabled ? '' : transition + ' 65ms',
    opacity: activeId === id ? 0 : 1,
    position: 'relative' as const,
    zIndex: disabled ? 10 : 1,
    overflow: 'visible' as const,
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      {...(disabled ? {} : attributes)}
      {...(disabled ? {} : listeners)}
      className='tile'
    >
      <Item
        pattern={pattern}
        isDragging={isDragging}
        hintLocked={hintLocked}
      />
    </div>
  );
};

export default SortableItem;
